document.addEventListener("DOMContentLoaded", () => {
  let mql = window.matchMedia("(max-width: 38em)");

  if (mql.matches) {
    document
      .querySelectorAll("[data-stack-on-mobile][data-carousel")
      .forEach((el) => {
        el.removeAttribute("data-carousel");
      });
  }
});

(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
})();
